/*
  Product-card interactions: swatch image-swap, swatch overflow arrow, and
  image swipe/hover cycling. Extracted from snippets/card-product.liquid
  (audit f37, 2026-06-10): the snippet rendered this whole script once PER
  card, so a 48-product collection page shipped ~313 KB of duplicated inline
  script. It is now a single deferred asset loaded once per page.

  Every listener is delegated on `document`, so a single global load handles
  every card on the page (and no-ops on pages with no cards). The
  __goesslCardSwatchesInit guard is retained as belt-and-suspenders in case
  the file is ever included twice.
*/
(function() {
  if (window.__goesslCardSwatchesInit) return;
  window.__goesslCardSwatchesInit = true;

  // Swatch click: swap image, update link, set active
  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('.goessl-product-card__swatch');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();

    var card = swatch.closest('.goessl-product-card');
    if (!card) return;
    var img = card.querySelector('.goessl-product-card__img');
    var link = card.querySelector('.goessl-product-card__link');

    // Swap main image
    if (img && swatch.dataset.imageSrc) {
      img.src = swatch.dataset.imageSrc;
      img.srcset = swatch.dataset.imageSrcset || '';
      img.dataset.baseSrc = swatch.dataset.imageSrc;
      img.dataset.cardIndex = '0';
    }

    // Deep link to this color's variant
    if (link && swatch.dataset.variantId) {
      var url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', swatch.dataset.variantId);
      link.href = url.toString();
    }

    // Update active state
    card.querySelectorAll('.goessl-product-card__swatch').forEach(function(s) {
      s.classList.remove('active');
    });
    swatch.classList.add('active');

    // Clear swipe images for new color (no client-side image list available)
    card.removeAttribute('data-card-images');
    var dotsWrap = card.querySelector('[data-card-dots]');
    if (dotsWrap) dotsWrap.style.display = 'none';
  });

  // Overflow detection: show arrow when swatches overflow
  function checkOverflow() {
    document.querySelectorAll('.goessl-product-card__swatches-wrap').forEach(function(wrap) {
      var el = wrap.querySelector('.goessl-product-card__swatches');
      if (!el) return;
      if (el.scrollWidth > el.clientWidth) {
        wrap.classList.add('has-overflow');
      } else {
        wrap.classList.remove('has-overflow');
      }
    });
  }

  // Arrow click: scroll swatches right, or wrap to start
  document.addEventListener('click', function(e) {
    var arrow = e.target.closest('.goessl-product-card__swatches-arrow');
    if (!arrow) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = arrow.closest('.goessl-product-card__swatches-wrap');
    var container = wrap && wrap.querySelector('.goessl-product-card__swatches');
    if (!container) return;
    var scrollAmount = container.clientWidth * 0.6;
    if (container.scrollLeft + container.clientWidth >= container.scrollWidth - 5) {
      container.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkOverflow);
  } else {
    checkOverflow();
  }
  window.addEventListener('resize', checkOverflow);

  // Image swipe: cycle through product images on touch swipe or hover segments
  var swipeState = {};

  document.addEventListener('touchstart', function(e) {
    var imageWrap = e.target.closest('.goessl-product-card__image');
    var card = imageWrap && imageWrap.closest('[data-card-images]');
    if (!card) return;
    swipeState = { card: card, startX: e.touches[0].clientX, startY: e.touches[0].clientY };
  }, { passive: true });

  document.addEventListener('touchend', function(e) {
    if (!swipeState.card) return;
    var dx = e.changedTouches[0].clientX - swipeState.startX;
    var dy = e.changedTouches[0].clientY - swipeState.startY;
    if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)) {
      e.preventDefault();
      var images = swipeState.card.dataset.cardImages.split('|');
      var img = swipeState.card.querySelector('.goessl-product-card__img');
      var dots = swipeState.card.querySelectorAll('.goessl-product-card__dot');
      if (!img || images.length < 2) { swipeState = {}; return; }
      var current = parseInt(img.dataset.cardIndex || '0', 10);
      var next = dx < 0 ? current + 1 : current - 1;
      next = ((next % images.length) + images.length) % images.length;
      img.src = images[next];
      img.srcset = '';
      img.dataset.cardIndex = next;
      dots.forEach(function(d, i) { d.classList.toggle('is-active', i === next); });
      var dotsWrap = swipeState.card.querySelector('[data-card-dots]');
      if (dotsWrap) dotsWrap.classList.add('is-visible');
    }
    swipeState = {};
  });

  // Desktop: hover over left/right halves to cycle images
  document.addEventListener('mousemove', function(e) {
    var imageWrap = e.target.closest('.goessl-product-card__image');
    var card = imageWrap && imageWrap.closest('[data-card-images]');
    if (!card) return;
    var images = card.dataset.cardImages.split('|');
    if (images.length < 2) return;
    var img = card.querySelector('.goessl-product-card__img');
    var dots = card.querySelectorAll('.goessl-product-card__dot');
    if (!img) return;
    var rect = imageWrap.getBoundingClientRect();
    var relX = (e.clientX - rect.left) / rect.width;
    var idx = Math.min(Math.floor(relX * images.length), images.length - 1);
    var current = parseInt(img.dataset.cardIndex || '0', 10);
    if (idx !== current) {
      img.src = images[idx];
      img.srcset = '';
      img.dataset.cardIndex = idx;
      dots.forEach(function(d, i) { d.classList.toggle('is-active', i === idx); });
    }
  });

  // Reset to base image on mouse leave (swatch-selected or first)
  document.addEventListener('mouseout', function(e) {
    var imageWrap = e.target.closest('.goessl-product-card__image');
    if (!imageWrap || imageWrap.contains(e.relatedTarget)) return;
    var card = imageWrap.closest('.goessl-product-card');
    if (!card) return;
    var img = card.querySelector('.goessl-product-card__img');
    var dots = card.querySelectorAll('.goessl-product-card__dot');
    if (!img) return;
    var baseSrc = img.dataset.baseSrc;
    var images = (card.dataset.cardImages || '').split('|');
    if (baseSrc) {
      img.src = baseSrc;
    } else if (images.length > 1) {
      img.src = images[0];
    }
    img.srcset = '';
    img.dataset.cardIndex = '0';
    dots.forEach(function(d, i) { d.classList.toggle('is-active', i === 0); });
  });
})();
